import React from 'react'

import { AutoCompleteComponent } from '@syncfusion/ej2-react-dropdowns';

import { getMixedProps } from './blockPublic'
import { useEventHandler } from 'tyan/public/hooks'

const AutoComplete = ({
	config: {
		field: {
			callback,		// 回调函数，参数为(text, 函数(用于回传新备选数据，参数内容为字符串数组))；如有此配置，以下配置无效
			event,
			params = {},		// 用于向后台取数据的event，以及发送到后台的参数(对象)，后台返回为:{data:[]}
			...field
		}, onChange, defaultStyle
	}
}) => {
	const { name } = field

	const handleChange = useEventHandler(({ value }) => {
		onChange({ name, newValue: value, type: 'string' })
	})

	const handleFiltering = e => {
		const { text } = e

		const doFilter = data => e.updateData(data, null)

		text
			? callback
				? callback(text, doFilter)
				: event && Tyan.doPostEvent(event, {
					data: { text, ...params },
					onEnd: ({ errorMessage, data }) => {
						errorMessage && Ext.toast(errorMessage)
						doFilter(data || [])
					}
				})
			: (doFilter([]), handleChange({ value: null }))
	}

	let { props: { disabled, clearable, ...props } } = getMixedProps('_autoComplete', [defaultStyle, field])

	return <AutoCompleteComponent {...props} /* {...labelContext} */
		enabled={!disabled}
		showClearButton={clearable}
		change={handleChange}
		filtering={handleFiltering}
	/>
}

const renderAutoComplete = config => {
	const { key } = config.field || {}
	return <AutoComplete key={key} config={config} />
}


export default renderAutoComplete